/*
 * @Description: 客户中心接口
 * @version: 1.0.0
 * @Author: Monkey
 * @Date: 2023-04-07 14:36:41
 * @LastEditors: Monkey
 * @LastEditTime: 2025-05-13 19:48:51
 */
import config from '@/config';
import http from '@/utils/request';

export default {
  company: {
    list: {
      url: `${config.API_URL}/customer/company/page`,
      name: '获取业务客户公司信息',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    find: {
      url: `${config.API_URL}/customer/company/findById`,
      name: '查询业务客户公司',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    save: {
      url: `${config.API_URL}/customer/company/save`,
      name: '业务客户公司保存',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    update: {
      url: `${config.API_URL}/customer/company/update`,
      name: '业务客户公司更新',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
  },
  follow: {
    save: {
      url: `${config.API_URL}/customer/company/follow/save`,
      name: '添加公司跟进',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    list: {
      url: `${config.API_URL}/customer/company/follow/list`,
      name: '获取公司跟进列表',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    }
  },
  log: {
    url: `${config.API_URL}/customer/company/logs/page`,
    name: '获取公司日志信息',
    get: async function (params, config) {
      config = Object.assign({ codeFlag: true }, config)
      return await http.post(this.url, params, config);
    },
  },
  contact: {
    list: {
      url: `${config.API_URL}/customer/company/findContacts`,
      name: '获取公司联系人信息',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
  }
}
